export default {"src":"/_next/static/media/briefcase.3c99def1.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};